// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d_xC","colMin":"styles_colMin__j6S95"};